// extracted by mini-css-extract-plugin
export default {"rotateSpin":"lucky-spin_rotateSpin__3mb5j","spin":"lucky-spin_spin__CE4-S"};